import { ca } from '@cian/analytics';

export const trackBookingBannerShow = () => trackBookingBannerEvent('Show_sopr');
export const trackBookingBannerClick = () => trackBookingBannerEvent('Click_sopr');

function trackBookingBannerEvent(action: 'Show_sopr' | 'Click_sopr') {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action,
    label: 'booking_confident_banner',
    useLastProducts: true,
  });
}
